var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "26px",
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP_CompanyDESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM-Homeowners-dropdown",
    transform: "translate(-1129.000000, -258.000000)",
    fill: "#9B9B9B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(1094.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(35.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62762238,15.8733739 C5.47866404,15.8733739 4.54428904,14.9389989 4.54428904,13.7900405 C4.54428904,12.6410822 5.47866404,11.7067072 6.62762238,11.7067072 C7.77658071,11.7067072 8.71095571,12.6410822 8.71095571,13.7900405 C8.71095571,14.9389989 7.77658071,15.8733739 6.62762238,15.8733739 M10.5994974,0.883790542 C10.475539,0.784832209 10.313039,0.747332209 10.1609557,0.781707209 L0.785955711,2.86504054 C0.547414044,2.91712388 0.377622378,3.12962388 0.377622378,3.37337388 L0.377622378,23.1650405 C0.377622378,23.4087905 0.547414044,23.6202489 0.785955711,23.6733739 L10.1609557,25.7567072 C10.197414,25.7650405 10.2359557,25.7692072 10.2734557,25.7692072 C10.391164,25.7692072 10.5057474,25.7296239 10.5994974,25.6546239 C10.722414,25.5556655 10.794289,25.4067072 10.794289,25.2483739 L10.794289,1.29004054 C10.794289,1.13170721 10.722414,0.982748876 10.5994974,0.883790542",
    id: "Fill-4908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6484557,14.9358974 C13.784914,14.9358974 13.0859557,14.2369391 13.0859557,13.3733974 C13.0859557,12.5098558 13.784914,11.8108974 14.6484557,11.8108974 L19.3359557,11.8150641 L19.3359557,2.95673077 C19.3359557,2.66923077 19.1026224,2.43589744 18.8151224,2.43589744 L12.044289,2.43589744 L12.044289,23.2692308 L18.8151224,23.2692308 C19.1026224,23.2692308 19.3359557,23.0358974 19.3359557,22.7483974 L19.3359557,14.9400641 L14.6484557,14.9358974 Z",
    id: "Fill-4909"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.523451,13.7174536 L24.3464927,13.7174536 L19.7571475,17.4606369 C19.4727744,17.6926524 19.4727744,18.0698263 19.7571475,18.3030316 C20.042979,18.5350471 20.5038093,18.5350471 20.7896408,18.3030316 L26.6229363,13.5437395 C26.9073094,13.3105341 26.9073094,12.9333602 26.6229363,12.7013447 L20.7896408,7.94324239 C20.5052677,7.7112269 20.042979,7.7112269 19.7586058,7.94324239 C19.4727744,8.17644771 19.4727744,8.55243179 19.7571475,8.78444728 C19.7586058,8.78563711 22.600879,11.1046022 24.3464927,12.5276306 L11.523451,12.5276306 C11.1209536,12.5276306 10.794289,12.7941509 10.794289,13.1225421 C10.794289,13.4509333 11.1209536,13.7174536 11.523451,13.7174536",
    id: "Fill-4910"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout.1f48eb34de20d4bb216a811037533940.svg";